import { Link, StackProps, Text } from '@chakra-ui/react'
import SectionStack from 'components/common/SectionStack'
import { useBrandCookie } from 'hooks/helpers/useBrandCookie'
import { FC } from 'react'

const MoreQuestionsSection: FC<StackProps> = (props) => {
  const isOmensFit = useBrandCookie('isWeightAddress')

  if (isOmensFit) return null

  return (
    <SectionStack spacing="6" {...props}>
      <Text textStyle={{ base: 'body1sm', lg: 'body1' }} pb="4px" borderBottom="2px solid #25241E">
        Para mais dúvidas
      </Text>

      <Text textStyle={{ base: 'h5sm', lg: 'h5' }}>
        Ainda tem dúvidas? Acesse nossa página de{' '}
        <Link color="dandelion" href="/faq">
          ajuda e perguntas frequentes.
        </Link>
      </Text>

      <Text textStyle={{ base: 'body2sm', lg: 'body2' }}>
        Disclaimer: A Omens não é um serviço de urgência. Para qualquer emergência, ligue para 192 (Brasil)
      </Text>
    </SectionStack>
  )
}

export default MoreQuestionsSection
